import { gql } from "@apollo/client";

export const getPublishedEvents = /* GraphQL */ gql`
  query GetPublishedEvents($eventType: String!) {
    getPublishedEvents(eventType: $eventType) {
      id
      eventName
      eventDescription
      startDateUTC
      endDateUTC
      dayOfTheWeek
      startTime
      endTime
      imageUrl
      videoUrl
      eventType
      eventCategory
      hosts {
        id
        name
        bio
        summary
        imageUrl
        thumbUrl
        organisation
        from
      }
      tags {
        id
        name
        category
      }
      locations {
        id
        title
        description
        latitude
        longitude
        imageUrl
        thumbUrl
        owner
        locationNotes {
          id
          note
          category
        }
      }
    }
  }
`;
export const getEventHosts = /* GraphQL */ gql`
  query GetEventHosts($eventType: String!) {
    getEventHosts(eventType: $eventType) {
      id
      name
      bio
      summary
      imageUrl
      thumbUrl
      organisation
      from
    }
  }
`;
export const getEventLocations = /* GraphQL */ gql`
  query GetEventLocations($eventType: String!) {
    getEventLocations(eventType: $eventType) {
      id
      title
      description
      latitude
      longitude
      imageUrl
      thumbUrl
      owner
      locationNotes {
        id
        note
        category
      }
    }
  }
`;
 